import {
  BriefcaseIcon,
  HomeIcon,
  UserIcon,
  KeyIcon,
} from "@heroicons/react/solid";

import { ROUTES } from "Route/ConstantRoute";

const SidebarProfileRoute = [
  {
    name: "Kembali Ke Menu",
    href: ROUTES.dashboard,
    icon: HomeIcon,
    current: false,
  },
  {
    name: "Informasi Pribadi",
    href: ROUTES.profile.information,
    icon: UserIcon,
    current: false,
  },
  {
    name: "Kata Sandi",
    href: ROUTES.profile.password,
    icon: KeyIcon,
    current: false,
  },
];

export { SidebarProfileRoute };
